<template>
  <section class="faq-section">
    <h2>FAQs</h2>
    <p class="subHeading">All you need to know to invest with confidence.</p>

    <div v-if="showMessage" role="status" class="no-results">No FAQs Found..</div>

    <div v-else class="content">
      <CommonFaqAccordion v-for="(faq, index) in faqs" :key="faq._id || index" :faq="faq" />
    </div>
  </section>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import faqService from "~/service/faqService";
// import CommonFaqAccordion from "~/components/CommonFaqAccordion.vue";

const faqs = ref([]);
const showMessage = ref(false);

const fetchFaqs = async () => {
  try {
    const response = await faqService.getAllFaqs();
    const data = response.data;

    if (data && data.length > 0) {
      // Map top-level FAQs
      faqs.value = await Promise.all(
        data.map(async (item: any) => {
          const faqItem: any = {
            _id: item._id,
            question: item.title,
            answer: item.description,
            nested: [],
          };

          // Fetch nested FAQs only for top-level
          try {
            const nestedResponse = await faqService.getFaqByEntity(item._id);
            const nestedData = nestedResponse.data;
            if (nestedData && nestedData.length > 0) {
              faqItem.nested = nestedData.map((nestedItem: any) => ({
                _id: nestedItem._id,
                question: nestedItem.title,
                answer: nestedItem.description,
                nested: [], // children of child are empty, no further API call
              }));
            }
          } catch (err) {
            console.error("Error fetching nested FAQs for top-level:", err);
          }

          return faqItem;
        })
      );

      showMessage.value = false;
    } else {
      showMessage.value = true;
    }
  } catch (error) {
    console.error("Error fetching FAQs:", error);
    showMessage.value = true;
  }
};

onMounted(() => {
  fetchFaqs();
});
</script>

<style scoped>
section {
  flex-direction: column;
}

.content {
  margin-top: 30px;
  width: 96%;
}

@media (min-width: 1025px) {
  .content {
    width: 80%;
  }
}
</style>